import { fileAccessLogConstants } from "_constants";

const getFileAccessLog = (filters) => {
  // filters: { claimId, fileID, userId, startDate, endDate, lob }
  return {
    type: fileAccessLogConstants.GET_FILE_ACCESS_LOG_REQUEST,
    payload: filters,
  };
};

const clearFileAccessLog = () => {
  return {
    type: fileAccessLogConstants.CLEAR_FILE_ACCESS_LOG,
  };
};

export const fileAccessLogActions = {
  getFileAccessLog,
  clearFileAccessLog,
};
